/**
 * 「請求書記載情報」（請求書に載せる自社の情報）の、画面の文。
 *
 * ここ1か所にまとめて、自社設定の一覧・編集画面・請求書管理の案内で
 * 言い方が割れないようにする（項目の名前は invoiceIssuerFields.js）。
 *
 * 文は Gemini が決めたもの（2026-10-09、CI-14・CI-15・CI-17・CI-19〜CI-21。決め直しを含む。
 * CI-19 の項目の名前の前後は、答えの形のとおり半角の空白）。言い回しを変えない。
 */

/** 自社設定の一覧のカードの見出しと、編集画面の見出し。 */
export const INVOICE_ISSUER_TITLE = '請求書記載情報'

/** 見出しの下の説明。何に使う情報かを1行で。 */
export const INVOICE_ISSUER_SUMMARY =
  '請求書に記載される自社の情報を設定します。'

/** 編集画面で、会社名と電話番号（ここでは直せない）の下に出す案内。 */
export const INVOICE_ISSUER_FIXED_NOTE =
  '会社名および電話番号も請求書に記載されます。変更する場合は、自社設定の「会社情報」から変更してください。'

/**
 * 請求書管理で、まだ空の項目があるときに出す案内。
 *
 * @param {string[]} labels 空の項目の名前（invoiceIssuerFields.js の label）
 */
export function invoiceIssuerMissingNotice (labels) {
  return '請求書に記載する自社情報のうち、' + labels.join('・') +
    'が未設定です。このまま請求書を出力すると、該当の欄は空欄になります。'
}

/** 上の案内に続けて出す、入れる場所の案内（自社設定を開ける人にはリンクにする）。 */
export const INVOICE_ISSUER_WHERE_TO_SET =
  '設定画面を開く'

/** 自社設定を開けない人に出す、頼む相手の案内。 */
export const INVOICE_ISSUER_ASK_ADMIN =
  '設定の変更は、自社設定を変更できる管理者に依頼してください。'
